import type { FaireProductEntity } from "../../entity_types/product";

export const p_tbe3wausy9: FaireProductEntity = {
  token: "p_tbe3wausy9",
  type: "product",
  name: "Circles Iraca Tray - Straw Raffia Tableware",
  brandToken: "b_rz9qg9uuan",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/8812d22e5b10686f451b56a5e9eacdce725c6f47b5cd3f9e5a55c8e7f681fba8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d91dafc3f20de5e67682008912214b5849da5e7db098bbaefe9c8db9cd4626cf.png",
    "https://cdn.faire.com/fastly/7ac2f8118199ca9c2f3ff477cbd60c665e6d6a7fd34501b6088eb1154d2cf367.jpeg",
  ],
  priceDollars: 52.5,
  description:
    'Fun and unique Iraca palm tray, handmade by women artisans from the Caribbean coast of Colombia. Using a traditional weaving technique from the region, they are a work of art that will bring the ultimate touch of boho chic to your table.\n\nDiameter: 40cm / 15.75"\n\nAll of our items are 100% handmade from natural fibers. Please allow for any color and sizing variations, or natural imperfections created during the hand making process.\n\nThank you :)',
  tags: [],
  msrpDollars: 105,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:34.215Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
